export const END_APPOINTMENT_REASONS = [
  { code: 'DECEASED', label: 'Deceased' },
  { code: 'RESIGNATION', label: 'Resignation' },
  { code: 'RETIREMENT', label: 'Retirement' },
  { code: 'TERM_ENDED', label: 'Term ended / not renewed' },
  { code: 'REMOVED', label: 'Removed by board resolution' },
  { code: 'OTHER', label: 'Other' },
];

export function endReasonLabel(code) {
  const match = END_APPOINTMENT_REASONS.find((r) => r.code === code);
  return match?.label || code || 'Ended';
}
